import React from "react";
import { PageMeta } from "@/components/PageMeta";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { BRAND, CONTACT } from "@/config/brand";

export default function Privacy() {
    return (
        <div>
            <PageMeta title="Privacy Policy — YS Removals" description="How YS Removals collects, uses and protects your information." canonical={`https://${BRAND.domain}/privacy-policy`} />
            <section className="bg-[#001B3D] text-white">
                <div className="container-ys section">
                    <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Privacy Policy" }]} />
                    <h1 className="mt-3 text-4xl font-semibold font-heading">Privacy Policy</h1>
                </div>
            </section>
            <section className="container-ys section prose prose-neutral max-w-3xl">
                <p>This privacy policy explains what information YS Removals collects when you use our website and services, why we collect it, and your rights.</p>
                <h2>What we collect</h2>
                <ul>
                    <li>Contact information you provide (name, phone, email, address details)</li>
                    <li>Details you provide about your move (inventory, dates, access notes, uploaded photos)</li>
                    <li>Technical information such as IP address and browser type</li>
                </ul>
                <h2>Why we collect it</h2>
                <ul>
                    <li>To prepare and deliver quotations, bookings and services you request</li>
                    <li>To reply to your enquiries and provide customer support</li>
                    <li>To meet our legal obligations and prevent fraud</li>
                </ul>
                <h2>How enquiries are handled</h2>
                <p>Your enquiry is stored securely and only accessible to the YS Removals team.</p>
                <h2>How long we keep information</h2>
                <p>We keep enquiry data for as long as we need it to provide our services and to comply with legal requirements.</p>
                <h2>Who we may share information with</h2>
                <p>We do not sell your data. Where necessary we may share information with service providers (e.g. hosting, email delivery) under appropriate agreements.</p>
                <h2>Your rights</h2>
                <p>You have rights under UK GDPR including access, correction, deletion and objection. To exercise them, contact us at {CONTACT.email}.</p>
            </section>
        </div>
    );
}
